<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				用户列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 15px;display: flex;align-items: center;" class="search">
				
				
				<el-select v-model="form.software" filterable clearable placeholder="请选择所属软件"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(key,value) in software_info" :key="software_info[value].id" :label="value"
						:value="value">
					</el-option>
				</el-select>
				<el-select v-model="form.user_state" clearable placeholder="请选择状态"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(key,value) in user_state_conf" :key="key" :label="user_state_conf[value]"
						:value="value">
					</el-option>
					<el-option  label="正常"
						value="normal">
					</el-option>
				</el-select>
				<el-input clearable placeholder="账号" v-model="form.username" size="small"
					style="width: 250px;margin-right: 20px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				
				<!-- <div style="display: flex; align-items: center;margin-left: auto;">
					<el-button type="success" size="small" style="border-radius: 0;" :disabled="multipleSelection.length===0" @click="toAddTime">续存</el-button>
					<el-button type="danger" size="small" style="border-radius: 0;"
						:disabled="multipleSelection.length===0" @click="deleteAll">删除</el-button>
				</div> -->
			</div>
			<div style="padding: 0px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					@selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					 v-loading="loading">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="username" label="账号" min-width="100" show-overflow-tooltip>
					</el-table-column>
					<el-table-column label="在线状态" width="120" align="center">
						<template slot-scope="scope">
							{{is_online(scope.row,software_info,now_timestamp)}}
						</template>
					</el-table-column>
					<el-table-column label="用户状态" width="120" align="center">
						<template slot-scope="scope">
							{{user_state_trans(scope.row,now_timestamp)}}
						</template>
					</el-table-column>
					<el-table-column label="到期时间" width="160" align="center">
						<template slot-scope="scope">
							{{scope.row.endtime|formatTime}}
						</template>
					</el-table-column>
					<el-table-column label="最近使用时间" width="160" align="center">
						<template slot-scope="scope">
							{{scope.row.usetime|formatTime}}
						</template>
					</el-table-column>
					<el-table-column label="所属软件" width="160" align="center">
						<template slot-scope="scope">
							{{scope.row.software}}
						</template>
					</el-table-column>
					<el-table-column label="多端同时在线数量" width="180" align="center">
						<template slot-scope="scope">
							{{scope.row.max_num}}
						</template>
					</el-table-column>
					<el-table-column label="备注" align="left"  show-overflow-tooltip prop="one">
						<template slot-scope="scope">
							{{scope.row.one||'-'}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200" align="center">
						<template slot-scope="scope">
							
							<el-button style="padding: 5px;" type="warning" size="mini" @click="toEdit(scope.row.username)">修改</el-button>
							<el-button style="padding: 5px;" type="danger" size="mini" @click="toDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer">
				<el-pagination layout="total, prev, pager, next,sizes" @current-change="toPage" :total="total"
					:page-sizes="[10,25,50,100]" :current-page="form.page" :page-size="form.limit"  @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		data() {
			return {
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page:1,
					software:"",
					user_state:"",
					username:"",
					limit:10,
				},
				type_config: {},
				software_info: {},
				now_timestamp: 0,
				user_state_conf: {},
				list: [],
				multipleSelection: []
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return '-'
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		created() {
			this.getData()
			this.now_timestamp = window.localStorage.getItem('timestamp_'+this.$store.state.user.center_id)
		},
		methods: {
			
			toAddTime(){
				let cards = this.multipleSelection.map(item=>item.card)
				this.addTime(cards)
			},
			addTime(input_cards) {
				this.$prompt('请输入续期时间(天，可以是小数)', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputType: 'number'
				}).then(({
					value
				}) => {
					this.$H.post('verify_center/v1_0_1.Card/Option', {
						option: 'input_cards_time_add',
						days: value,
						cards: input_cards
					}).then(res => {
						if(!res.data) return;
						const h = this.$createElement;
						let list = []
						if (res.data.num == res.data.count) {
							list.push(h('p', {
								style: 'display:flex;justify-content: center;'
							}, '全部处理成功'))
						} else {
							list.push(h('p', {
								style: 'display:flex;justify-content: center;'
							}, '失败的有'))
							for (let i = 0; i < res.data.not_exist_cards.length; i++) {
								list.push(h('p', {
									style: 'display:flex;justify-content: center'
								}, res.data.not_exist_cards[i]))
							}
							list.push(h('p', {
								style: 'display:flex;justify-content: center;'
							}, '(点击确认自动复制)'))
						}

						this.$msgbox({
							title: '成功【' + res.data.num + '】个，失败【' + (res.data.count - res.data
								.num) + '】个',
							message: h('p', {
								style: 'color:#ccc;padding:10px'
							}, list),
							showCancelButton: true,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(action => {
							console.log(action)
							if (res.data.num != res.data.count) {
								this.$copyText(res.data.not_exist_cards.join(',')).then((e) => {
									this.$message.success('复制成功')
									console.log(e)
								}, (e) => {
									console.log(e)
								})
							}
							this.dialogVisible = false
							this.dialogOptions = false
							this.cards = ''
							this.search()
						}).catch(err => {
							this.dialogVisible = false
							this.dialogOptions = false
							this.search()
						});
					});
				}).catch(() => {

				});
			},
			confromCard() {
				this.dialogOptions = true
			},
			toEdit(username) {
				this.$emit('toEdit', username)

			},
			deleteAll() {
				let ids = this.multipleSelection.map(item => item.id)
				this.$confirm('是否删除选中卡密?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Card/Option',{
						option: 'delete',
						cards_id: ids
					},{token:true}).then(res => {
						if(!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					}).catch(err=>{
						console.log(err)
					});

				}).catch(() => {

				});
			},
			toDelete(item) {
				console.log(item.id)
				this.$confirm('是否删除该用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(12313)
					this.$H.post('/verify_center/v1_0_1.User/Option', {
						user_id:item.id,
						option:'delete_checked'
					},{token:true}).then(res => {
						if(!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});

				}).catch(() => {

				});
			},
			is_online(card_info, software_info, now_timestamp) {
				let heart_beat_time = 30;
				if (software_info[card_info.software] != undefined) heart_beat_time = software_info[card_info.software]
					.heart_beat_time;
				if (now_timestamp - card_info.usetime < heart_beat_time && card_info.usetime > 0) return '在线';
				return '离线';
			},
			user_state_trans(user_info, now_timestamp) {
				if(user_info.status > 1) return '冻结';
				if(user_info.endtime < now_timestamp && user_info.type != 9) return '到期';
				return '正常';
			},
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.User/List', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.type_config = res.data.type_config
							this.software_info = res.data.software_info
							this.user_state_conf = res.data.user_state_conf
							this.total = res.data.list.total
						}

						this.list = res.data.list.data

					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			},
			handleSizeChange(val){
				this.form.limit = val
				this.form.page = 1
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>